<template>
  <div>
    <v-row>
      <v-col class="mt-10 pt-10" style="min-width: 24.5rem; max-width: 24.5rem">
        <template v-if="mainGrammar == 'Edit'">
          <div class="dragArea">
            <draggable
              :list="fieldsGrammar"
              class="ma-0 pa-3"
              style="min-height: 24.5rem"
              :group="{ name: 'formbuilder', pull: false, put: true }"
              :sort="true"
              @change="changeFieldsGrammar"
              ghost-class="sortable__ghost"
            >
              <template v-for="(field, index) in fieldsGrammar">
                <v-col
                  :cols="field.cols"
                  :key="`${field.fieldType}-${field.id}`"
                  class="form__group pa-0 my-2"
                  :class="{ 'is--active': field === activeFieldGrammar }"
                >
                  <div
                    class="pa-0 width-10"
                    @click="editElementProperties(field)"
                    :id="'form-' + index"
                  >
                    <component
                      :is="field.fieldType"
                      :currentField="field"
                      class="form__field"
                    />
                  </div>

                  <!-- Actions list -->
                  <div class="form__actiongroup">
                    <!-- <v-icon class="form__actionitem--move">fas fa-arrows-alt</v-icon> -->
                    <div class="form__actionlist">
                      <v-icon small @click="deleteElement(index, fieldsGrammar)"
                        >fas fa-times-circle</v-icon
                      >
                    </div>
                  </div>
                </v-col>
              </template>
            </draggable>
          </div>
        </template>
        <template v-else>
          <div class="preview overflow-y-auto">
            <v-row class="ma-0">
              <v-col
                v-for="(field, index) in fieldsGrammar"
                :key="index"
                v-bind="field"
                class="py-1"
                :cols="field.cols"
                :class="{ 'is--active': field === activeFieldGrammar }"
              >
                <component
                  :is="field.fieldType"
                  :currentField="field"
                  class="form__field not-border"
                ></component>
              </v-col>
            </v-row>
          </div>
        </template>
      </v-col>
      <v-col style="min-width: 25rem; max-width: 25rem" :offset-lg="1">
        <div class="d-flex">
          <v-spacer />
          <v-select
            class="mt-3 mr-3"
            style="max-width: 160px"
            :items="language"
            outlined
            hide-details
            dense
            v-if="mainGrammar == 'Preview'"
            v-model="isLanguage"
            item-value="key"
          />
          <v-btn
            class="mt-3 mr-3"
            color="primary"
            @click="
              mainGrammar == 'Edit'
                ? (mainGrammar = 'Preview')
                : (mainGrammar = 'Edit')
            "
            >{{ mainGrammar == "Edit" ? "プレビュー" : $t("EDIT") }}</v-btn
          >
          <v-btn
            class="primary mt-3"
            @click="hanldeSave"
            :loading="loading"
            :disabled="loading"
            >更新</v-btn
          >
        </div>
        <v-card class="mt-5">
          <v-tabs v-model="activeTabForFieldsGrammar" light>
            <v-tab href="#elements">項目追加</v-tab>
            <v-tab
              href="#properties"
              v-if="activeTabForFieldsGrammar == 'properties'"
              >{{ activeFieldGrammar.text }}</v-tab
            >
            <v-spacer />
            <v-tooltip bottom v-if="!_.isEmpty(activeFieldGrammar)">
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  color="primary"
                  dark
                  class="my-auto mr-4"
                  v-bind="attrs"
                  @click="cloneElement"
                  v-on="on"
                >
                  far fa-clone
                </v-icon>
              </template>
              <span>コピー</span>
            </v-tooltip>
          </v-tabs>
          <v-tabs-items v-model="activeTabForFieldsGrammar">
            <v-tab-item value="elements">
              <v-card flat>
                <elements />
              </v-card>
            </v-tab-item>
            <v-tab-item
              value="properties"
              v-show="activeTabForFieldsGrammar == 'properties'"
            >
              <v-card flat>
                <properties ref="properties" />
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <VocabularyList style="min-height: 80px" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { FormBuilder } from "@/components/form_elements_gramma/formbuilder";
import Elements from "@/components/form_elements_gramma/Elements";
import Upload from "@/components/Upload/Upload";
import background from "@/assets/download.png";
import VocabularyList from "./vocabulary/VocabularyList";
FormBuilder.$options.components["Elements"] = Elements;
FormBuilder.$options.components["Upload"] = Upload;
FormBuilder.$options.components["VocabularyList"] = VocabularyList;

const { v4: uuidv4 } = require("uuid");
// import { saveAs } from "file-saver";
import uploadFile from "@/utils/uploadFile";
import { updateGrammar } from "@/api/Grammar.api";
// import { createGrammar } from "@/api/Grammar.api";
import JsZip from "jszip";
import mixin from "@/mixin";

export default {
  mixins: [mixin.DetailGrammar],
  store: [
    "fieldsGrammar",
    "activeFieldGrammar",
    "activeTabForFieldsGrammar",
    "mainGrammar",
    "detailsGrammar",
    "isLanguage",
    "vocabularyGrammar",
  ],
  components: FormBuilder.$options.components,
  data() {
    return {
      background,
      image: null,
      status_intro: true,
      status_challenge: true,
      loading: false,
      language: [
        { text: "日本語", key: "ja" },
        { text: "日本語（かな）", key: "kana" },
        { text: "英語", key: "en" },
        { text: "中国語", key: "cn" },
        { text: "ベトナム語", key: "vn" },
        { text: "ベンガル語", key: "bn" },
        { text: "ポルトガル語", key: "pt" },
      ],
    };
  },
  async created() {
    await this.handleGetDetailGrammar();
  },
  methods: {
    async hanldeSave() {
      this.$toast.clear();
      if (!this.fieldsGrammar.find((e) => e.key == "Title"))
        return this.$toast.error("文法名が項目必須です。入力してください。");
      let validate = this.$refs.properties
        ? this.$refs.properties.handleCheckValidate()
        : false;
      let checkValueTypeText = this.fieldsGrammar.find(
        (e) => e.type == "text" && !e.value["ja"]
      );
      let checkValueImage = this.fieldsGrammar.find(
        (e) => e.type == "image" && !e.file
      );
      if (checkValueTypeText) {
        await this.editElementProperties(checkValueTypeText);
        this.$refs.properties.handleCheckValidate();
        return this.$toast.error(
          "多言語がある項目の日本語を入力してください。"
        );
      }
      // Check image null
      if (checkValueImage) {
        console.log("---------------");
        return this.$toast.error("挿絵データをアップロードしてください。");
      }
      this.loading = true;

      if ((!checkValueTypeText || !validate) && this.fieldsGrammar.length > 0) {
        let fields = [];
        this.fieldsGrammar.forEach((e) => fields.push(e));
        var folderImage = new JsZip().folder("image");
        fields.forEach((item) => {
          if (item.type == "image" && item.file && item.file.file) {
            console.log("image: ", item);
            let file = item.file.file;
            let splitType = file.name.split(".");
            let type = file.name.split(".")[splitType.length - 1];
            let uID = uuidv4();
            let name = `Grammar_${uID}.${type}`;
            item.file_name = `${name}`;
            folderImage.file(`${name}`, file);
          }
        });
        let params = {
          data: fields,
          section: "",
          vocabulary: this.vocabularyGrammar,
          id: this.detailsGrammar.Id,
        };
        await folderImage
          .generateAsync({ type: "blob" })
          .then(async (content) => {
            console.log("folderImage: ", content);
            content.name = "SUN.zip";
            await uploadFile(content, "image").then(async (e) => {
              params.fileNameImage = e;
            });
          });
        await updateGrammar(params).catch(() => (this.loading = false));
        this.$router.go(-1);
      }
      this.loading = false;
    },
    changeFieldsGrammar(e) {
      if (e.added) {
        e.added.element.id = `${uuidv4()}`;
        this.editElementProperties(e.added.element);
      } else if (e.moved) {
        this.editElementProperties(e.moved.element);
      }
    },
    deleteElement(index, form) {
      FormBuilder.deleteElement(index, form);
      this.activeTabForFieldsGrammar = "elements";
    },
    cloneElement() {
      const { activeFieldGrammar, fieldsGrammar, _ } = this;
      let index = _.findIndex(fieldsGrammar, function (o) {
        return o.id == activeFieldGrammar.id;
      });
      FormBuilder.cloneElement(
        index,
        activeFieldGrammar,
        fieldsGrammar,
        uuidv4()
      );
    },
    editElementProperties(field) {
      FormBuilder.editElementProperties(field);
    },
  },
  beforeDestroy() {
    this.isLanguage = "ja";
    this.fieldsGrammar = [];
    this.activeFieldGrammar = {};
    this.activeTabForFieldsGrammar = "elements";
    this.mainGrammar = "Edit";
    this.vocabularyGrammar = [];
  },
};
</script>
<style scoped>
::v-deep .form__group .not-border .explanatory-sentences {
  border: none !important;
  min-height: none !important;
}
</style>
<style lang="scss" scoped>
.v-card.v-card--flat.v-sheet.theme--light {
  border: none !important;
  border-radius: 0 !important;
  border-top: 1px solid #ccc !important;
}
.dragArea {
  position: relative;
  border-radius: 4px;
  min-height: 23rem;
  width: 100%;
  z-index: 2;
  background-color: #f5f3e5;
}

.background-content {
  height: 2rem;
  width: 94%;
  background-repeat: repeat-x;
  margin-left: 10px;
}
.background-content-sentence_struct {
  min-height: 2rem;
  // height: 13rem;
  background: white;
  margin-left: 11px;
  margin-right: 12px;
  padding: 10px;
}

.content-sentence_struct {
  border-radius: 4px;
  min-height: 3rem;
  background-color: #f5f3e5;
  padding: 10px;
}

.content-image {
  border: 2px solid #fe9365;
  height: 130px;
}
.form__actionitem--move {
  position: absolute;
  right: -14px;
  top: 50%;
  transform: translateY(-50%);
  visibility: hidden;

  &:active,
  &:focus,
  &:hover {
    border-color: #409eff;
    // background: #ecf5ff;
  }
}

.form__actionlist {
  position: absolute;
  visibility: hidden;
  z-index: 3;
  right: -10px;
  bottom: -11px;
  border-radius: 2px;
}

.form__group {
  //   margin-bottom: 1rem;
  margin: 0 15px 0 0;
  border: 1px solid transparent;
  position: relative;
  height: fit-content;
  &:hover {
    border: 1px solid #409eff !important;
    .form__actionitem--move {
      visibility: visible;
    }
    .form__actionlist {
      visibility: visible;
    }
  }

  &.is--active {
    border-color: #409eff;
    background: #ecf5ff;
    // padding: 0 8px !important;

    .form__actionlist {
      visibility: visible;
    }
    .form__selectedlabel {
      display: inline-block;
    }
  }
}

.preview {
  border: 1px solid #cccccc;
  height: 30rem;
}
</style>
